export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_10.1e93c021.jpg";